import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import * as _ from 'lodash';

import injectReducer from 'utils/injectReducer';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import {
  makeSelectStepPaymentDetails,
  makeSelectStepPaymentDetailsErrors,
} from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import Textbox from '../components/Textbox';
import {
  handleFormDataChange,
  nextSlide,
} from './actions';
import OptionsContainer from '../components/OptionsContainer';
import { saveFormData } from '../actions';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import { resetFormDataAddress } from './actions';
import MySelect from '../../../components/MySelect';
import {
  makeSelectClaimList,
  makeSelectTitleList,
} from '../../ClaimList/selectors';
import {
  makeSelectCountriesOfxSupported,
} from 'containers/FastCover/StepWhatHappened/selectors';
import { required, maxLength, validUSABankRoutingNumber } from '../../../utils/validation/validator';
import { ErrorMessage, Validate, ValidateGroup } from '../../../components/Validation';
import { getValidateBank, getCountryPaymentConfig } from '../../FastCover/actions';
import HelpText from '../../../components/HelpText';
import { makeSelectJSONVersion, makeSelectShowZurichUHC, makeSelectShowTrawickPaymentScreen } from '../../App/selectors';
import P from '../../../components/P';
import { AsyncCreatable } from 'react-select';
import { appConfig } from './../../../configureApp';
import { defaultCountry } from '../../FastCover/dataMapper/claimCodeMapper';

export class StepPaymentDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      showModal: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.saveButtonId = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
    this.invalidBSBWarning = null;

    this.lastCheckingBSB = props.form.bsbNumber;
  }

  componentDidMount() { }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
    if (value === 'SWIFT Code') {
      this.props.onFormDataChange('form.iban', '');
      this.props.onFormDataChange('form.bankCodeOrRoutingNumber', '');
    }

    if (value === 'IBAN') {
      this.props.onFormDataChange('form.swiftCode', '');
      this.props.onFormDataChange('form.bankCodeOrRoutingNumber', '');
      this.props.onFormDataChange('form.bankAccountNumber', '');
    }

    if (value === 'Bank Code') {
      this.props.onFormDataChange('form.swiftCode', '');
      this.props.onFormDataChange('form.iban', '');
    }
    // this.props.makeDirty(2);
  };

  handleChangeSelectPaymentVia = (propertyName) => (event) => {
    const {
      isSummary,
      claim,
    } = this.props;
    const {
      paymentTo,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
    if (value === 'Check' && paymentTo === 'Member') {
      this.setDataForAddress(claim);
    }
  };

  handleChangePaymentViaCheck = (propertyName) => (event) => {
    const {
      isSummary,
      claim,
    } = this.props;
    const {
      paymentTo,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }

    this.props.onResetFormDataAddress();
    if (value) {
      this.props.onFormDataChange('form.paymentVia', 'Check');
    } else {
      const country = {
        id: defaultCountry.id,
        label: defaultCountry.name,
        value: defaultCountry.name,
      };
      this.props.onFormDataChange('form.country', country);
      this.props.onFormDataChange('form.paymentVia', 'EFT');
    }
    this.props.onFormDataChange(propertyName, value);
  };

  setDataForAddress = (claim) => {
    const { titleList } = this.props;
    const title = titleList.find((x) => x.name === claim.title);
    this.props.onFormDataChange('form.addressLine1', claim.addressLine1);
    this.props.onFormDataChange('form.addressLine2', claim.addressLine2);
    this.props.onFormDataChange('form.mobile', claim.mobileNumber);
    this.props.onFormDataChange('form.firstName', claim.firstName);
    this.props.onFormDataChange('form.title', title !== null ? title.id : 1);
    this.props.onFormDataChange('form.lastName', claim.surname);
    this.props.onFormDataChange('form.state', claim.state);
    this.props.onFormDataChange('form.postalZipCode', claim.postalCode);
    this.props.onFormDataChange('form.city', claim.city);
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.checkBSBValidation();
    this.props.onFormDataSave();
    this.nextButton.focus();
    this.checkFormError();
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleChangeSelectPaymentTo = (propertyName) => (event) => {
    const {
      isSummary,
      claim,
    } = this.props;
    const {
      paymentVia,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
    if (paymentVia === 'Check' && value === 'Member') {
      this.setDataForAddress(claim);
    }
  };

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  checkBSBValidation = () => {
    const { isBsbValid, bsbCannotBeVerified } = this.props.form;
    if (!isBsbValid && !bsbCannotBeVerified) {
      this.showModal();
    }
  };

  loadCountry = (inputValue, callback) => {
    const {
      countryList,
    } = this.props;
    const countries = countryList && typeof countryList.toJS === 'function'
      ? countryList.toJS()
      : countryList || [];
    const countryListFiltered = countries.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    setTimeout(() => {
      callback(countryListFiltered);
    }, 1000);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }
    // const errors = this.validatorGroup.getErrors();
    this.checkFormError();

    this.props.onFormDataSave();
    this.props.next();
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleResetPartialFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => {
      if (typeof prop === 'boolean' || typeof prop === 'number') {
        return prop;
      }
      return prop || 'N/A';
    });
  }

  closeModal = () => {
    this.setState({ showModal: false });
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  handleChangeTitle = (v) => {
    this.props.onFormDataChange('form.title', v);
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleChangeCountry = (v) => {
    const { jsonVersion } = this.props;
    let countryId = 0;
    if (v && typeof v === 'object') {
      countryId = v === null ? 0 : v.id;
    } else {
      countryId = v === null ? 0 : v;
    }
    this.props.onFormDataChange('form.country', v);
    if (countryId !== 0 && jsonVersion > 6) {
      this.props.getCountryPaymentConfig(countryId);
    }
  };

  renderOldFNOLPaymentScreen() {
    const {
      isSummary,
      submitted,
      loading,
      titleList,
      countryList,
      jsonVersion,
      intl,
    } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      paymentTo,
      paymentVia,
      title,
      firstName,
      lastName,
      addressLine1,
      addressLine2,
      country,
      state,
      city,
      postalZipCode,
      mobile,
      // new UI
      bankTypeCode,
      bankCodeOrRoutingNumber,
      bank,
      bankAddress,
      bankSuburbOrCity,
      bankPostcode,
      bankBranch,
      bankAccountName,
      bankAccountNumber,
      swiftCode,
      iban,
      paymentTypeOptions,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const displayOldClaim = jsonVersion > 6;
    const newVersionCountry = jsonVersion > 9;
    let isShowIBAN = false;
    let isShowBankCode = false;
    let isShowSwiftCode = false;
    if (displayOldClaim) {
      isShowIBAN = paymentTypeOptions.includes('IBAN');
      isShowBankCode = paymentTypeOptions.includes('Bank Code');
      isShowSwiftCode = paymentTypeOptions.includes('SWIFT Code');
    }
    // Validate Account Number
    const valueAccountNumber = bankAccountNumber ? bankAccountNumber.toString() : '';
    const valueBankCode = bankCodeOrRoutingNumber ? bankCodeOrRoutingNumber.toString() : '';
    const valueSwiftCode = swiftCode ? swiftCode.toString() : '';
    const valueIban = iban ? iban.toString() : '';
    const valueBankAccountName = bankAccountName ? bankAccountName.toString() : '';
    const valueBankName = bank ? bank.toString() : '';
    const valueBankAddress = bankAddress ? bankAddress.toString() : '';
    const valueBankSuburb = bankSuburbOrCity ? bankSuburbOrCity.toString() : '';
    const valueBankPostCode = bankPostcode ? bankPostcode.toString() : '';
    const valueBankBranch = bankBranch ? bankBranch.toString() : '';
    const valueCheckFName = firstName ? firstName.toString() : '';
    const valueCheckLName = lastName ? lastName.toString() : '';
    const valueCheckAddress1 = addressLine1 ? addressLine1.toString() : '';
    const valueCheckAddress2 = addressLine2 ? addressLine2.toString() : '';
    const valueCheckCity = city ? city.toString() : '';
    const valueCheckState = state ? state.toString() : '';
    const valueCheckMobile = mobile ? mobile.toString() : '';
    const isValidateAccountNumber = valueAccountNumber.toString().trim().length > 17;
    const isValidateBankCode = valueBankCode.toString().trim().length > 32;
    const isValidateSwiftCode = valueSwiftCode.toString().trim().length > 11;
    const isValidateIban = valueIban.toString().trim().length > 34;
    const isValidateBankAccountName = valueBankAccountName.toString().trim().length > 128;
    const isValidateBankName = valueBankName.toString().trim().length > 64;
    const isValidateBankAddress = valueBankAddress.toString().trim().length > 120;
    const isValidateBankSuburb = valueBankSuburb.toString().trim().length > 100;
    const isValidateBankPostCode = valueBankPostCode.toString().trim().length > 31;
    const isValidateBankBranch = valueBankBranch.toString().trim().length > 120;
    const isValidateCheckFName = valueCheckFName.toString().trim().length > 50;
    const isValidateCheckLName = valueCheckLName.toString().trim().length > 50;
    const isValidateCheckAddress1 = valueCheckAddress1.toString().trim().length > 100;
    const isValidateCheckAddress2 = valueCheckAddress2.toString().trim().length > 100;
    const isValidateCheckCity = valueCheckCity.toString().trim().length > 100;
    const isValidateCheckState = valueCheckState.toString().trim().length > 100;
    const isValidateCheckMobile = valueCheckMobile.toString().trim().length > 20;
    const countries = countryList && typeof countryList.toJS === 'function'
      ? countryList.toJS()
      : countryList || [];

    const regex = /^\d{9}$/;
    const valueCountry = country === null ? '' : country.label;
    const valueBankTypeCode = bankTypeCode ? bankTypeCode.toString() : '';
    const USABankRoutingNumber = valueCountry === 'United States' && valueBankTypeCode === 'Bank Code';
    const isValidateUSABankCode = valueBankCode.toString().trim().length !== 9 || !regex.test(valueBankCode.trim());
    const { isValidate } = this.props.form;
    const showPaymentVia = appConfig.showPaymentVia;
    if (!showPaymentVia) {
      this.props.onFormDataChange('form.paymentVia', 'EFT');
    }
    return (
      <div className="app-content height-payment-details">
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.paymentOptions} />
            </PageSectionHeader>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-6 form-group'}>
            <Validate
              name="paymentTo"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={paymentTo}
              fieldName={messages.paymentTo}
            >
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Member"
                    checked={paymentTo === 'Member'}
                    onChange={this.handleChangeSelectPaymentTo('form.paymentTo')}
                  />
                  <FormattedMessage {...messages.memberInsured} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Family Member"
                    checked={paymentTo === 'Family Member'}
                    onChange={this.handleChange('form.paymentTo')}
                    onClick={this.props.onResetFormDataAddress}
                  />
                  <FormattedMessage {...messages.familyMember} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Provider"
                    checked={paymentTo === 'Provider'}
                    onChange={this.handleChange('form.paymentTo')}
                    onClick={this.props.onResetFormDataAddress}
                  />
                  <FormattedMessage {...messages.provider} />
                </OptionsContainer>
              </FlexBox>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.paymentTo' }) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-sm-6 form-group'}>
            <Validate
              name="paymentVia"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={paymentVia}
              fieldName={messages.paymentVia}
            >
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="EFT"
                    checked={paymentVia === 'EFT'}
                    onChange={this.handleChange('form.paymentVia')}
                    onClick={this.props.onResetFormDataAddress}
                  />
                  <FormattedMessage {...messages.EFT} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Check"
                    checked={paymentVia === 'Check'}
                    onChange={this.handleChangeSelectPaymentVia('form.paymentVia')}
                  />
                  <FormattedMessage {...messages.check} />
                </OptionsContainer>
              </FlexBox>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.paymentVia' }) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        {paymentVia === 'EFT' &&
          <div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.paymentDetails} />
                </PageSectionHeader>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.bankDetails} />
                </PageSectionHeader>
              </div>
            </div>
            <div className={'ml-3 row'}>
              {!newVersionCountry && (
                <div className={'form-group col-sm-6'}>
                  <Validate
                    name="country"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={country}
                    fieldName={messages.country}
                  >
                    <MySelect
                      dataList={countryList}
                      disabled={isReadOnly}
                      onChange={(v) => {
                        this.handleChangeCountry(v);
                      }}
                      value={country}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.country' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              )}
              {newVersionCountry && (
                <div className={'form-group col-sm-6'}>
                  <Validate
                    name="country"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={country}
                    fieldName={messages.country}
                  >
                    <AsyncCreatable
                      loadOptions={this.loadCountry}
                      name="country"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      styles={{
                        input: (styles) => ({ ...styles, border: 'none !important' }),
                      }}
                      value={
                        !!country && typeof country.toJS === 'function' ? country.toJS() : country
                      }
                      placeholder="Type a country"
                      isClearable
                      isDisabled={isReadOnly}
                      onChange={(e) => {
                        this.handleChangeCountry(e);
                      }}
                      defaultOptions={countries}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.country' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              )}
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-12 form-group'}>
                <HelpText>
                  <FormattedMessage {...messages.confirmSelectCountry} />
                </HelpText>
              </div>
            </div>
            {(country !== null && displayOldClaim) &&
              <div>
                <div className={'ml-3 row'}>
                  <div className={'col-md-6 form-group'}>
                    <Validate
                      name="bankTypeCode"
                      validators={[required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankTypeCode}
                      fieldName={messages.bankTypeCode}
                    >
                      <FlexBox>

                        {isShowBankCode &&
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              checked={bankTypeCode === 'Bank Code'}
                              onChange={this.handleChange('form.bankTypeCode')}
                              value="Bank Code"
                            />
                            <FormattedMessage {...messages.bankCode} />
                          </OptionsContainer>
                        }
                        {isShowSwiftCode &&
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              checked={bankTypeCode === 'SWIFT Code'}
                              onChange={this.handleChange('form.bankTypeCode')}
                              value="SWIFT Code"
                            />
                            <FormattedMessage {...messages.swiftCode} />
                          </OptionsContainer>
                        }
                        {isShowIBAN &&
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              checked={bankTypeCode === 'IBAN'}
                              onChange={this.handleChange('form.bankTypeCode')}
                              value="IBAN"
                            />
                            <FormattedMessage {...messages.IBANText} />
                          </OptionsContainer>
                        }
                      </FlexBox>
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankTypeCode' }) }}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                </div>
                {bankTypeCode === 'SWIFT Code' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-8 form-group'}>
                      <Validate
                        name="swiftCode"
                        validators={[required, maxLength(11)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={swiftCode}
                        fieldName={messages.swiftCode}
                      >
                        <Textbox
                          disabled={isReadOnly || isValidate}
                          name="swiftCode"
                          type="text"
                          onChange={this.handleChange('form.swiftCode')}
                          value={swiftCode}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.swiftCode' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateSwiftCode &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidSwiftCode} />
                        </P>
                      }
                    </div>
                  </div>}
                {bankTypeCode === 'IBAN' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-8 form-group'}>
                      <Validate
                        name="iban"
                        validators={[required, maxLength(34)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={iban}
                        fieldName={messages.IBANText}
                      >
                        <Textbox
                          disabled={isReadOnly || isValidate}
                          name="iban"
                          type="text"
                          onChange={this.handleChange('form.iban')}
                          value={iban}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.IBANText}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateIban &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidIban} />
                        </P>
                      }
                      <PageSectionHeader>
                        <FormattedMessage {...messages.reminderIban} />
                      </PageSectionHeader>
                    </div>
                  </div>}
                {(bankTypeCode === 'Bank Code' || bankTypeCode === '') &&
                  <div className={'ml-3 row'}>
                    {USABankRoutingNumber &&
                      <div className={'col-sm-8 form-group'}>
                        <Validate
                          name="bankCode"
                          validators={[required, validUSABankRoutingNumber]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={bankCodeOrRoutingNumber}
                          fieldName={messages.bankCodeOrRoutingNumber}
                        >
                          <Textbox
                            disabled={isReadOnly}
                            name="bankCode"
                            type="text"
                            onChange={this.handleChange('form.bankCodeOrRoutingNumber')}
                            value={bankCodeOrRoutingNumber}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.bankCodeOrRoutingNumber}
                            />
                          </ErrorMessage>
                        </Validate>
                        {isValidateUSABankCode &&
                          <P style={{ color: 'red', fontSize: '0.7em' }}>
                            <FormattedMessage {...messages.isValidUASBankCode} />
                          </P>
                        }
                      </div>
                    }
                    {!USABankRoutingNumber &&
                      <div className={'col-sm-8 form-group'}>
                        <Validate
                          name="bankCode"
                          validators={[required, maxLength(32)]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={bankCodeOrRoutingNumber}
                          fieldName={messages.bankCodeOrRoutingNumber}
                        >
                          <Textbox
                            disabled={isReadOnly}
                            name="bankCode"
                            type="text"
                            onChange={this.handleChange('form.bankCodeOrRoutingNumber')}
                            value={bankCodeOrRoutingNumber}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.bankCodeOrRoutingNumber}
                            />
                          </ErrorMessage>
                        </Validate>
                        {isValidateBankCode &&
                          <P style={{ color: 'red', fontSize: '0.7em' }}>
                            <FormattedMessage {...messages.isValidBankCode} />
                          </P>
                        }
                      </div>
                    }
                    <div className={'col-sm-4 form-group'}>
                    </div>
                  </div>}
                <div className={'ml-3 row'}>
                  <div className={'col-sm-6 form-group'}>
                    <Validate
                      name="bank"
                      validators={[maxLength(64)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bank}
                      fieldName={messages.bank}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bank"
                        type="text"
                        onChange={this.handleChange('form.bank')}
                        value={bank}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankName &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bank' }) }}
                        />
                      </P>
                    }
                  </div>
                  <div className={'col-sm-6 form-group'}>
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="bankAddress"
                      validators={[maxLength(120)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankAddress}
                      fieldName={messages.bankAddress}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankAddress"
                        type="text"
                        onChange={this.handleChange('form.bankAddress')}
                        value={bankAddress}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankAddress &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAddress' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-8 form-group'}>
                    <Validate
                      name="bankSuburbOrCity"
                      validators={[maxLength(100)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankSuburbOrCity}
                      fieldName={messages.bankSuburbOrCity}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankSuburbOrCity"
                        type="text"
                        onChange={this.handleChange('form.bankSuburbOrCity')}
                        value={bankSuburbOrCity}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankSuburb &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankSuburbOrCity' }) }}
                        />
                      </P>
                    }
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <Validate
                      name="bankPostcode"
                      validators={[maxLength(31)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankPostcode}
                      fieldName={messages.bankPostcode}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankPostcode"
                        type="text"
                        onChange={this.handleChange('form.bankPostcode')}
                        value={bankPostcode}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankPostCode &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankPostcode' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-8 form-group'}>
                    <Validate
                      name="bankBranch"
                      validators={[maxLength(120)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankBranch}
                      fieldName={messages.bankBranch}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankBranch"
                        type="text"
                        onChange={this.handleChange('form.bankBranch')}
                        value={bankBranch}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankBranch &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankBranch' }) }}
                        />
                      </P>
                    }
                  </div>
                  <div className={'col-sm-4 form-group'}>
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  {(bankTypeCode === 'Bank Code' || bankTypeCode === 'SWIFT Code' || bankTypeCode === 'IBAN') &&
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountName"
                        validators={[required, maxLength(128)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountName}
                        fieldName={messages.bankAccountName}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountName"
                          type="text"
                          onChange={this.handleChange('form.bankAccountName')}
                          value={bankAccountName}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountName' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateBankAccountName &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidBankAccountName} />
                        </P>
                      }
                    </div>}
                  {bankTypeCode === '' &&
                    <div className={'col-sm-6 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.bankAccountName} />
                      </PageSectionHeader>
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankAccountName"
                        type="text"
                        onChange={this.handleChange('form.bankAccountName')}
                        value={bankAccountName}
                      />
                    </div>}
                  {(bankTypeCode === 'Bank Code' || bankTypeCode === 'SWIFT Code') &&
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountNumber"
                        validators={[required, maxLength(17)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountNumber}
                        fieldName={messages.bankAccountNumber}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountNumber"
                          type="text"
                          onChange={this.handleChange('form.bankAccountNumber')}
                          value={bankAccountNumber}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountNumber' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateAccountNumber &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidAccountNumber} />
                        </P>
                      }
                    </div>}
                  {(bankTypeCode === '' || bankTypeCode === 'IBAN') &&
                    <div className={'col-sm-6 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.bankAccountNumber} />
                      </PageSectionHeader>
                      <Textbox
                        disabled
                        name="bankAccountNumber"
                        type="text"
                        onChange={this.handleChange('form.bankAccountNumber')}
                        value={bankAccountNumber}
                      />
                    </div>}
                </div>
                <div className={'row ml-3'}>
                  <div className={'form-group col-sm-12'}>
                    <HelpText>
                      Please attach the wire transfer instructions from your financial institution (this can be obtained via online baking app, website or a call to the bank).
                    </HelpText>
                  </div>
                </div>
              </div>
            }
            {!displayOldClaim &&
              <div>
                <div className={'ml-3 row'}>
                  <div className={'col-md-6 form-group'}>
                    <Validate
                      name="bankTypeCode"
                      validators={[required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankTypeCode}
                      fieldName={messages.bankTypeCode}
                    >
                      <FlexBox>
                        <OptionsContainer>
                          <input
                            disabled={isReadOnly}
                            type="radio"
                            checked={bankTypeCode === 'Bank Code'}
                            onChange={this.handleChange('form.bankTypeCode')}
                            value="Bank Code"
                          />
                          <FormattedMessage {...messages.bankCode} />
                        </OptionsContainer>
                        <OptionsContainer>
                          <input
                            disabled={isReadOnly}
                            type="radio"
                            checked={bankTypeCode === 'SWIFT Code'}
                            onChange={this.handleChange('form.bankTypeCode')}
                            value="SWIFT Code"
                          />
                          <FormattedMessage {...messages.swiftCode} />
                        </OptionsContainer>
                        <OptionsContainer>
                          <input
                            disabled={isReadOnly}
                            type="radio"
                            checked={bankTypeCode === 'IBAN'}
                            onChange={this.handleChange('form.bankTypeCode')}
                            value="IBAN"
                          />
                          <FormattedMessage {...messages.IBANText} />
                        </OptionsContainer>
                      </FlexBox>
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankTypeCode' }) }}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                </div>
                {bankTypeCode === 'SWIFT Code' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-8 form-group'}>
                      <Validate
                        name="swiftCode"
                        validators={[required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={swiftCode}
                        fieldName={messages.swiftCode}
                      >
                        <Textbox
                          disabled={isReadOnly || isValidate}
                          name="swiftCode"
                          type="text"
                          onChange={this.handleChange('form.swiftCode')}
                          value={swiftCode}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.swiftCode' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                    </div>
                  </div>}
                {bankTypeCode === 'IBAN' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-8 form-group'}>
                      <Validate
                        name="iban"
                        validators={[required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={iban}
                        fieldName={messages.IBANText}
                      >
                        <Textbox
                          disabled={isReadOnly || isValidate}
                          name="iban"
                          type="text"
                          onChange={this.handleChange('form.iban')}
                          value={iban}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.IBANText}
                          />
                        </ErrorMessage>
                      </Validate>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.reminderIban} />
                      </PageSectionHeader>
                    </div>
                  </div>}
                {(bankTypeCode === 'Bank Code' || bankTypeCode === '') &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-8 form-group'}>
                      <Validate
                        name="bankCode"
                        validators={[required, maxLength(32)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankCodeOrRoutingNumber}
                        fieldName={messages.bankCodeOrRoutingNumber}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankCode"
                          type="text"
                          onChange={this.handleChange('form.bankCodeOrRoutingNumber')}
                          value={bankCodeOrRoutingNumber}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankCodeOrRoutingNumber' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateBankCode &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidBankCode} />
                        </P>
                      }
                    </div>
                    <div className={'col-sm-4 form-group'}>
                    </div>
                  </div>}
                <div className={'ml-3 row'}>
                  <div className={'col-sm-6 form-group'}>
                    <Validate
                      name="bank"
                      validators={[maxLength(64)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bank}
                      fieldName={messages.bank}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bank"
                        type="text"
                        onChange={this.handleChange('form.bank')}
                        value={bank}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankName &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bank' }) }}
                        />
                      </P>
                    }
                  </div>
                  <div className={'col-sm-6 form-group'}>
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="bankAddress"
                      validators={[maxLength(120)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankAddress}
                      fieldName={messages.bankAddress}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankAddress"
                        type="text"
                        onChange={this.handleChange('form.bankAddress')}
                        value={bankAddress}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankAddress &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAddress' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-8 form-group'}>
                    <Validate
                      name="bankSuburbOrCity"
                      validators={[maxLength(100)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankSuburbOrCity}
                      fieldName={messages.bankSuburbOrCity}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankSuburbOrCity"
                        type="text"
                        onChange={this.handleChange('form.bankSuburbOrCity')}
                        value={bankSuburbOrCity}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankSuburb &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankSuburbOrCity' }) }}
                        />
                      </P>
                    }
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <Validate
                      name="bankPostcode"
                      validators={[maxLength(31)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankPostcode}
                      fieldName={messages.bankPostcode}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankPostcode"
                        type="text"
                        onChange={this.handleChange('form.bankPostcode')}
                        value={bankPostcode}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankPostCode &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankPostcode' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-8 form-group'}>
                    <Validate
                      name="bankBranch"
                      validators={[maxLength(120)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankBranch}
                      fieldName={messages.bankBranch}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankBranch"
                        type="text"
                        onChange={this.handleChange('form.bankBranch')}
                        value={bankBranch}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankBranch &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankBranch' }) }}
                        />
                      </P>
                    }
                  </div>
                  <div className={'col-sm-4 form-group'}>
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  {(bankTypeCode === 'Bank Code' || bankTypeCode === 'SWIFT Code' || bankTypeCode === 'IBAN') &&
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountName"
                        validators={[required, maxLength(128)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountName}
                        fieldName={messages.bankAccountName}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountName"
                          type="text"
                          onChange={this.handleChange('form.bankAccountName')}
                          value={bankAccountName}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountName' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateBankAccountName &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidBankAccountName} />
                        </P>
                      }
                    </div>}
                  {bankTypeCode === '' &&
                    <div className={'col-sm-6 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.bankAccountName} />
                      </PageSectionHeader>
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankAccountName"
                        type="text"
                        onChange={this.handleChange('form.bankAccountName')}
                        value={bankAccountName}
                      />
                    </div>}
                  {(bankTypeCode === 'Bank Code' || bankTypeCode === 'SWIFT Code') &&
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountNumber"
                        validators={[required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountNumber}
                        fieldName={messages.bankAccountNumber}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountNumber"
                          type="text"
                          onChange={this.handleChange('form.bankAccountNumber')}
                          value={bankAccountNumber}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountNumber' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                    </div>}
                  {(bankTypeCode === '' || bankTypeCode === 'IBAN') &&
                    <div className={'col-sm-6 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.bankAccountNumber} />
                      </PageSectionHeader>
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankAccountNumber"
                        type="text"
                        onChange={this.handleChange('form.bankAccountNumber')}
                        value={bankAccountNumber}
                      />
                    </div>}
                </div>
                <div className={'row ml-3'}>
                  <div className={'form-group col-sm-12'}>
                    <HelpText>
                      Please attach the wire transfer instructions from your financial institution (this can be obtained via online baking app, website or a call to the bank).
                    </HelpText>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        {paymentVia === 'Check' &&
          <div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.checkAddress} />
                </PageSectionHeader>
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="title"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={title}
                  fieldName={messages.title}
                >
                  <MySelect
                    dataList={titleList}
                    name="title"
                    disabled={isReadOnly}
                    onChange={(v) => {
                      this.handleChangeTitle(v);
                    }}
                    value={title}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.title' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="firstName"
                  validators={[required, maxLength(50)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={firstName}
                  fieldName={messages.firstName}
                >
                  <Textbox
                    name="firstName"
                    type="text"
                    onChange={this.handleChange('form.firstName')}
                    value={firstName}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.firstName' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckFName &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.firstName' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="lastName"
                  validators={[required, maxLength(50)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={lastName}
                  fieldName={messages.lastName}
                >
                  <Textbox
                    name="lastName"
                    type="text"
                    onChange={this.handleChange('form.lastName')}
                    value={lastName}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.lastName' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckLName &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.lastName' }) }}
                    />
                  </P>
                }
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressLine1"
                  validators={[required, maxLength(100)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressLine1}
                  fieldName={messages.addressLine1}
                >
                  <Textbox
                    name="addressLine1"
                    type="text"
                    onChange={this.handleChange('form.addressLine1')}
                    value={addressLine1}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.addressLine1' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckAddress1 &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.addressLine1' }) }}
                    />
                  </P>
                }
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.addressLine2} />
                </PageSectionHeader>
                <Textbox
                  disabled={isReadOnly || isValidate}
                  name="addressLine2"
                  type="text"
                  onChange={this.handleChange('form.addressLine2')}
                  value={addressLine2}
                />
                {isValidateCheckAddress2 &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.addressLine2' }) }}
                    />
                  </P>
                }
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="city"
                  validators={[required, maxLength(100)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={city}
                  fieldName={messages.city}
                >
                  <Textbox
                    name="city"
                    type="text"
                    onChange={this.handleChange('form.city')}
                    value={city}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    {/* <FormattedMessage
                      {...messages.isRequired}
                      values={messages.city}
                    /> */}
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.city' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckCity &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.city' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="state"
                  validators={[required, maxLength(100)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={state}
                  fieldName={messages.state}
                >
                  <Textbox
                    name="state"
                    type="text"
                    onChange={this.handleChange('form.state')}
                    value={state}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    {/* <FormattedMessage
                      {...messages.isRequired}
                      values={messages.state}
                    /> */}
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.state' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckState &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.state' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="country"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={country}
                  fieldName={messages.country}
                >
                  <AsyncCreatable
                    loadOptions={this.loadCountry}
                    name="country"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      input: (styles) => ({ ...styles, border: 'none !important' }),
                    }}
                    value={
                      !!country && typeof country.toJS === 'function' ? country.toJS() : country
                    }
                    placeholder="Type a country"
                    isClearable
                    isDisabled={isReadOnly}
                    onChange={(e) => {
                      this.handleChangeCountry(e);
                    }}
                    defaultOptions={countries}
                  />
                  <ErrorMessage for="required">
                    {/* <FormattedMessage
                      {...messages.isRequired}
                      values={messages.country}
                    /> */}
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.country' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="postalZipCode"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={postalZipCode}
                  fieldName={messages.postalZipCode}
                >
                  <Textbox
                    name="postalZipCode"
                    type="number"
                    onChange={this.handleChange('form.postalZipCode')}
                    value={postalZipCode}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    {/* <FormattedMessage
                      {...messages.isRequired}
                      values={messages.postalZipCode}
                    /> */}
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.postalZipCode' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="mobile"
                  validators={[required, maxLength(20)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={mobile}
                  fieldName={messages.mobile}
                >
                  <Textbox
                    name="mobile"
                    type="text"
                    onChange={this.handleChangePhoneNumber('form.mobile')}
                    value={mobile}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.mobile' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckMobile &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.mobile' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
              </div>
            </div>
          </div>}
      </div>
    );
  }

  renderV14FNOLPaymentScreen() {
    const {
      isSummary,
      submitted,
      loading,
      titleList,
      countryList,
      intl,
    } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      paymentTo,
      paymentVia,
      title,
      firstName,
      lastName,
      addressLine1,
      addressLine2,
      country,
      state,
      city,
      postalZipCode,
      mobile,
      // new UI
      bankTypeCode,
      bankCodeOrRoutingNumber,
      bank,
      bankAddress,
      bankSuburbOrCity,
      bankPostcode,
      bankBranch,
      bankAccountName,
      bankAccountNumber,
      swiftCode,
      iban,
      paymentTypeOptions,
      isCheckPayment,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    // Validate Account Number
    const valueAccountNumber = bankAccountNumber ? bankAccountNumber.toString() : '';
    const valueBankCode = bankCodeOrRoutingNumber ? bankCodeOrRoutingNumber.toString() : '';// re-use
    const valueSwiftCode = swiftCode ? swiftCode.toString() : '';
    const valueIban = iban ? iban.toString() : '';
    const valueBankAccountName = bankAccountName ? bankAccountName.toString() : '';
    const valueBankName = bank ? bank.toString() : '';
    const valueBankAddress = bankAddress ? bankAddress.toString() : '';
    const valueBankSuburb = bankSuburbOrCity ? bankSuburbOrCity.toString() : '';
    const valueBankPostCode = bankPostcode ? bankPostcode.toString() : '';
    const valueBankBranch = bankBranch ? bankBranch.toString() : '';
    const valueCheckFName = firstName ? firstName.toString() : '';
    const valueCheckLName = lastName ? lastName.toString() : '';
    const valueCheckAddress1 = addressLine1 ? addressLine1.toString() : '';
    const valueCheckAddress2 = addressLine2 ? addressLine2.toString() : '';
    const valueCheckCity = city ? city.toString() : '';
    const valueCheckState = state ? state.toString() : '';
    const valueCheckMobile = mobile ? mobile.toString() : '';
    const isValidateAccountNumber = valueAccountNumber.toString().trim().length > 17;
    const isValidateBankCode = valueBankCode.toString().trim().length > 32;
    const isValidateSwiftCode = valueSwiftCode.toString().trim().length > 11;
    const isValidateIban = valueIban.toString().trim().length > 34;
    const isValidateBankAccountName = valueBankAccountName.toString().trim().length > 128;
    const isValidateBankName = valueBankName.toString().trim().length > 64;
    const isValidateBankAddress = valueBankAddress.toString().trim().length > 120;
    const isValidateBankSuburb = valueBankSuburb.toString().trim().length > 100;
    const isValidateBankPostCode = valueBankPostCode.toString().trim().length > 31;
    const isValidateBankBranch = valueBankBranch.toString().trim().length > 120;
    const isValidateCheckFName = valueCheckFName.toString().trim().length > 50;
    const isValidateCheckLName = valueCheckLName.toString().trim().length > 50;
    const isValidateCheckAddress1 = valueCheckAddress1.toString().trim().length > 100;
    const isValidateCheckAddress2 = valueCheckAddress2.toString().trim().length > 100;
    const isValidateCheckCity = valueCheckCity.toString().trim().length > 100;
    const isValidateCheckState = valueCheckState.toString().trim().length > 100;
    const isValidateCheckMobile = valueCheckMobile.toString().trim().length > 20;
    const countries = countryList && typeof countryList.toJS === 'function'
      ? countryList.toJS()
      : countryList || [];

    const regex = /^\d{9}$/;
    const { isValidate } = this.props.form;
    // new UI
    const countryDetails = !!country && typeof country.toJS === 'function' ? country.toJS() : country;
    const isUnitedStates = countryDetails === null ? false : countryDetails.id === defaultCountry.id;
    if (isUnitedStates) {
      this.props.onFormDataChange('form.bankTypeCode', 'Bank Code');
    }
    const isValidateUSABankCode = valueBankCode === '' ? false : valueBankCode.toString().trim().length !== 9 || !regex.test(valueBankCode.trim());
    return (
      <div className="app-content height-payment-details">
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.paymentOptions} />
            </PageSectionHeader>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-8 form-group'}>
            <Validate
              name="paymentTo"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={paymentTo}
              fieldName={messages.paymentTo}
            >
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Member"
                    checked={paymentTo === 'Member'}
                    onChange={this.handleChangeSelectPaymentTo('form.paymentTo')}
                  />
                  <FormattedMessage {...messages.memberInsured} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Family Member"
                    checked={paymentTo === 'Family Member'}
                    onChange={this.handleChange('form.paymentTo')}
                    onClick={this.props.onResetFormDataAddress}
                  />
                  <FormattedMessage {...messages.familyMember} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Provider"
                    checked={paymentTo === 'Provider'}
                    onChange={this.handleChange('form.paymentTo')}
                    onClick={this.props.onResetFormDataAddress}
                  />
                  <FormattedMessage {...messages.provider} />
                </OptionsContainer>
              </FlexBox>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.paymentTo' }) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-sm-4 form-group'}>
          </div>
        </div>
        {(paymentTo !== '' && paymentVia !== 'Check') &&
          <div>
            <div className={'ml-3 row'}>
              <div className={'form-group col-sm-6'}>
                <Validate
                  name="country"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={country}
                  fieldName={messages.country}
                >
                  <AsyncCreatable
                    loadOptions={this.loadCountry}
                    name="country"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      input: (styles) => ({ ...styles, border: 'none !important' }),
                    }}
                    value={
                      !!country && typeof country.toJS === 'function' ? country.toJS() : country
                    }
                    placeholder="Type a country"
                    isClearable
                    isDisabled={isReadOnly}
                    onChange={(e) => {
                      this.handleChangeCountry(e);
                    }}
                    defaultOptions={countries}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.country' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'form-group col-sm-6'}></div>
            </div>
            {(country !== null) &&
              <div>
                {!isUnitedStates &&
                  <div className={'ml-3 row'}>
                    <div className={'col-md-12 form-group'}>
                      <Validate
                        name="bankTypeCode"
                        validators={[required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankTypeCode}
                        fieldName={messages.bankTypeCode}
                      >
                        <FlexBox>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              checked={bankTypeCode === 'Bank Code'}
                              onChange={this.handleChange('form.bankTypeCode')}
                              value="Bank Code"
                            />
                            <FormattedMessage {...messages.bankCode} />
                          </OptionsContainer>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              checked={bankTypeCode === 'SWIFT Code'}
                              onChange={this.handleChange('form.bankTypeCode')}
                              value="SWIFT Code"
                            />
                            <FormattedMessage {...messages.swiftCode} />
                          </OptionsContainer>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              checked={bankTypeCode === 'IBAN'}
                              onChange={this.handleChange('form.bankTypeCode')}
                              value="IBAN"
                            />
                            <FormattedMessage {...messages.IBANText} />
                          </OptionsContainer>
                        </FlexBox>
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankTypeCode' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                    </div>
                  </div>
                }
                {bankTypeCode === 'SWIFT Code' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-8 form-group'}>
                      <Validate
                        name="swiftCode"
                        validators={[required, maxLength(11)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={swiftCode}
                        fieldName={messages.swiftCode}
                      >
                        <Textbox
                          disabled={isReadOnly || isValidate}
                          name="swiftCode"
                          type="text"
                          onChange={this.handleChange('form.swiftCode')}
                          value={swiftCode}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.swiftCode' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateSwiftCode &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidSwiftCode} />
                        </P>
                      }
                    </div>
                  </div>}
                {bankTypeCode === 'IBAN' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-8 form-group'}>
                      <Validate
                        name="iban"
                        validators={[required, maxLength(34)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={iban}
                        fieldName={messages.IBANText}
                      >
                        <Textbox
                          disabled={isReadOnly || isValidate}
                          name="iban"
                          type="text"
                          onChange={this.handleChange('form.iban')}
                          value={iban}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.IBANText}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateIban &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidIban} />
                        </P>
                      }
                      <PageSectionHeader>
                        <FormattedMessage {...messages.reminderIban} />
                      </PageSectionHeader>
                    </div>
                  </div>}
                {(bankTypeCode === 'Bank Code' || bankTypeCode === '') &&
                  <div className={'ml-3 row'}>
                    {isUnitedStates &&
                      <div className={'col-sm-8 form-group'}>
                        <Validate
                          name="bankCode"
                          validators={[required, validUSABankRoutingNumber]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={bankCodeOrRoutingNumber}
                          fieldName={messages.bankCodeOrRoutingNumber9Digits}
                        >
                          <Textbox
                            disabled={isReadOnly}
                            name="bankCode"
                            type="text"
                            onChange={this.handleChange('form.bankCodeOrRoutingNumber')}
                            value={bankCodeOrRoutingNumber}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.bankCodeOrRoutingNumber}
                            />
                          </ErrorMessage>
                        </Validate>
                        {isValidateUSABankCode &&
                          <P style={{ color: 'red', fontSize: '0.7em' }}>
                            <FormattedMessage {...messages.isValidUASBankCode} />
                          </P>
                        }
                      </div>
                    }
                    {!isUnitedStates &&
                      <div className={'col-sm-8 form-group'}>
                        <Validate
                          name="bankCode"
                          validators={[required, maxLength(32)]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={bankCodeOrRoutingNumber}
                          fieldName={messages.bankCodeOrRoutingNumber}
                        >
                          <Textbox
                            disabled={isReadOnly}
                            name="bankCode"
                            type="text"
                            onChange={this.handleChange('form.bankCodeOrRoutingNumber')}
                            value={bankCodeOrRoutingNumber}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.bankCodeOrRoutingNumber}
                            />
                          </ErrorMessage>
                        </Validate>
                        {isValidateBankCode &&
                          <P style={{ color: 'red', fontSize: '0.7em' }}>
                            <FormattedMessage {...messages.isValidBankCode} />
                          </P>
                        }
                      </div>
                    }
                    <div className={'col-sm-4 form-group'}>
                    </div>
                  </div>}
                {bankTypeCode === 'IBAN' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountName"
                        validators={[required, maxLength(128)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountName}
                        fieldName={messages.bankAccountName}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountName"
                          type="text"
                          onChange={this.handleChange('form.bankAccountName')}
                          value={bankAccountName}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountName' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateBankAccountName &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidBankAccountName} />
                        </P>
                      }
                    </div>
                    <div className={'col-sm-6 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.bankAccountNumber} />
                      </PageSectionHeader>
                      <Textbox
                        disabled
                        name="bankAccountNumber"
                        type="text"
                        onChange={this.handleChange('form.bankAccountNumber')}
                        value={bankAccountNumber}
                      />
                    </div>
                  </div>
                }
                {bankTypeCode !== 'IBAN' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountName"
                        validators={[required, maxLength(128)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountName}
                        fieldName={messages.bankAccountName}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountName"
                          type="text"
                          onChange={this.handleChange('form.bankAccountName')}
                          value={bankAccountName}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountName' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateBankAccountName &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidBankAccountName} />
                        </P>
                      }
                    </div>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountNumber"
                        validators={[required, maxLength(17)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountNumber}
                        fieldName={messages.bankAccountNumber}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountNumber"
                          type="text"
                          onChange={this.handleChange('form.bankAccountNumber')}
                          value={bankAccountNumber}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountNumber' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateAccountNumber &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidAccountNumber} />
                        </P>
                      }
                    </div>
                  </div>
                }
                <div className={'ml-3 row'}>
                  <div className={'col-sm-6 form-group'}>
                    <Validate
                      name="bankName"
                      validators={[required, maxLength(64)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bank}
                      fieldName={messages.bankName}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankName"
                        type="text"
                        onChange={this.handleChange('form.bank')}
                        value={bank}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.bankName}
                        />
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankName &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankName' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="bankBranch"
                      validators={[required, maxLength(120)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankBranch}
                      fieldName={messages.bankBranchName}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankBranchName"
                        type="text"
                        onChange={this.handleChange('form.bankBranch')}
                        value={bankBranch}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.bankBranchName}
                        />
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankBranch &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankBranchName' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="bankAddress"
                      validators={[maxLength(120)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankAddress}
                      fieldName={messages.bankAddress}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankAddress"
                        type="text"
                        onChange={this.handleChange('form.bankAddress')}
                        value={bankAddress}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankAddress &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAddress' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-8 form-group'}>
                    <Validate
                      name="bankSuburbOrCity"
                      validators={[maxLength(100)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankSuburbOrCity}
                      fieldName={messages.bankSuburbOrCity}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankSuburbOrCity"
                        type="text"
                        onChange={this.handleChange('form.bankSuburbOrCity')}
                        value={bankSuburbOrCity}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankSuburb &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankSuburbOrCity' }) }}
                        />
                      </P>
                    }
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <Validate
                      name="bankPostcode"
                      validators={[maxLength(31)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankPostcode}
                      fieldName={messages.bankPostcode}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankPostcode"
                        type="text"
                        onChange={this.handleChange('form.bankPostcode')}
                        value={bankPostcode}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankPostCode &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankPostcode' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
        {paymentVia === 'Check' &&
          <div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="title"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={title}
                  fieldName={messages.title}
                >
                  <MySelect
                    dataList={titleList}
                    name="title"
                    disabled={isReadOnly}
                    onChange={(v) => {
                      this.handleChangeTitle(v);
                    }}
                    value={title}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.title' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="firstName"
                  validators={[required, maxLength(50)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={firstName}
                  fieldName={messages.firstName}
                >
                  <Textbox
                    name="firstName"
                    type="text"
                    onChange={this.handleChange('form.firstName')}
                    value={firstName}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.firstName' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckFName &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.firstName' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="lastName"
                  validators={[required, maxLength(50)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={lastName}
                  fieldName={messages.lastName}
                >
                  <Textbox
                    name="lastName"
                    type="text"
                    onChange={this.handleChange('form.lastName')}
                    value={lastName}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.lastName' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckLName &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.lastName' }) }}
                    />
                  </P>
                }
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressLine1"
                  validators={[required, maxLength(100)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressLine1}
                  fieldName={messages.addressLine1}
                >
                  <Textbox
                    name="addressLine1"
                    type="text"
                    onChange={this.handleChange('form.addressLine1')}
                    value={addressLine1}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.addressLine1' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckAddress1 &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.addressLine1' }) }}
                    />
                  </P>
                }
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.addressLine2} />
                </PageSectionHeader>
                <Textbox
                  disabled={isReadOnly || isValidate}
                  name="addressLine2"
                  type="text"
                  onChange={this.handleChange('form.addressLine2')}
                  value={addressLine2}
                />
                {isValidateCheckAddress2 &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.addressLine2' }) }}
                    />
                  </P>
                }
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="city"
                  validators={[required, maxLength(100)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={city}
                  fieldName={messages.city}
                >
                  <Textbox
                    name="city"
                    type="text"
                    onChange={this.handleChange('form.city')}
                    value={city}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.city' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckCity &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.city' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="state"
                  validators={[required, maxLength(100)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={state}
                  fieldName={messages.state}
                >
                  <Textbox
                    name="state"
                    type="text"
                    onChange={this.handleChange('form.state')}
                    value={state}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.state' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckState &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.state' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="country"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={country}
                  fieldName={messages.country}
                >
                  <AsyncCreatable
                    loadOptions={this.loadCountry}
                    name="country"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      input: (styles) => ({ ...styles, border: 'none !important' }),
                    }}
                    value={
                      !!country && typeof country.toJS === 'function' ? country.toJS() : country
                    }
                    placeholder="Type a country"
                    isClearable
                    isDisabled={isReadOnly}
                    onChange={(e) => {
                      this.handleChangeCountry(e);
                    }}
                    defaultOptions={countries}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.country' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="postalZipCode"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={postalZipCode}
                  fieldName={messages.postalZipCode}
                >
                  <Textbox
                    name="postalZipCode"
                    type="number"
                    onChange={this.handleChange('form.postalZipCode')}
                    value={postalZipCode}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.postalZipCode' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="mobile"
                  validators={[required, maxLength(20)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={mobile}
                  fieldName={messages.mobile}
                >
                  <Textbox
                    name="mobile"
                    type="text"
                    onChange={this.handleChangePhoneNumber('form.mobile')}
                    value={mobile}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.mobile' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckMobile &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.mobile' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
              </div>
            </div>
          </div>}
        <div className={'row ml-3'}>
          <div className={'form-group col-sm-12'}>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="checkbox"
                value="Check"
                checked={isCheckPayment === true}
                onChange={this.handleChangePaymentViaCheck('form.isCheckPayment')}
                onClick={this.props.onResetFormDataAddress}
              />
              <div style={{ color: '#6d6b6b' }}>
                <FormattedMessage {...messages.alternativelyText} />
              </div>
            </OptionsContainer>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      isSummary,
      submitted,
      loading,
      intl,
      jsonVersion,
      showTrawickPaymentScreen,
    } = this.props;
    const isVersion14AndAbove = jsonVersion >= 14;
    const isReadOnly = submitted || isSummary;
    const isTrawickPaymentScreen = isVersion14AndAbove;
    return (
      <div>
        {(!isTrawickPaymentScreen) && this.renderOldFNOLPaymentScreen()}
        {(isTrawickPaymentScreen) && this.renderV14FNOLPaymentScreen()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className={`${appConfig.reactAppEnv === 'scti' ? 'base-button back-button' : 'btn-outline'}`}
                    onClick={() => {
                      this.props.prev();

                      // make sure next button is not focus, avoid break wizard slider
                      if (document.activeElement) {
                        document.activeElement.blur();
                      }
                    }}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.back' })}
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.save' })}
                </AsyncButton>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderV14FNOLPaymentScreen() {
    const {
      isSummary,
      submitted,
      loading,
      titleList,
      countryList,
      intl,
    } = this.props;
    const isReadOnly = submitted || isSummary;
    const {
      paymentTo,
      paymentVia,
      title,
      firstName,
      lastName,
      addressLine1,
      addressLine2,
      country,
      state,
      city,
      postalZipCode,
      mobile,
      // new UI
      bankTypeCode,
      bankCodeOrRoutingNumber,
      bank,
      bankAddress,
      bankSuburbOrCity,
      bankPostcode,
      bankBranch,
      bankAccountName,
      bankAccountNumber,
      swiftCode,
      iban,
      paymentTypeOptions,
      isCheckPayment,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    // Validate Account Number
    const valueAccountNumber = bankAccountNumber ? bankAccountNumber.toString() : '';
    const valueBankCode = bankCodeOrRoutingNumber ? bankCodeOrRoutingNumber.toString() : '';// re-use
    const valueSwiftCode = swiftCode ? swiftCode.toString() : '';
    const valueIban = iban ? iban.toString() : '';
    const valueBankAccountName = bankAccountName ? bankAccountName.toString() : '';
    const valueBankName = bank ? bank.toString() : '';
    const valueBankAddress = bankAddress ? bankAddress.toString() : '';
    const valueBankSuburb = bankSuburbOrCity ? bankSuburbOrCity.toString() : '';
    const valueBankPostCode = bankPostcode ? bankPostcode.toString() : '';
    const valueBankBranch = bankBranch ? bankBranch.toString() : '';
    const valueCheckFName = firstName ? firstName.toString() : '';
    const valueCheckLName = lastName ? lastName.toString() : '';
    const valueCheckAddress1 = addressLine1 ? addressLine1.toString() : '';
    const valueCheckAddress2 = addressLine2 ? addressLine2.toString() : '';
    const valueCheckCity = city ? city.toString() : '';
    const valueCheckState = state ? state.toString() : '';
    const valueCheckMobile = mobile ? mobile.toString() : '';
    const isValidateAccountNumber = valueAccountNumber.toString().trim().length > 17;
    const isValidateBankCode = valueBankCode.toString().trim().length > 32;
    const isValidateSwiftCode = valueSwiftCode.toString().trim().length > 11;
    const isValidateIban = valueIban.toString().trim().length > 34;
    const isValidateBankAccountName = valueBankAccountName.toString().trim().length > 128;
    const isValidateBankName = valueBankName.toString().trim().length > 64;
    const isValidateBankAddress = valueBankAddress.toString().trim().length > 120;
    const isValidateBankSuburb = valueBankSuburb.toString().trim().length > 100;
    const isValidateBankPostCode = valueBankPostCode.toString().trim().length > 31;
    const isValidateBankBranch = valueBankBranch.toString().trim().length > 120;
    const isValidateCheckFName = valueCheckFName.toString().trim().length > 50;
    const isValidateCheckLName = valueCheckLName.toString().trim().length > 50;
    const isValidateCheckAddress1 = valueCheckAddress1.toString().trim().length > 100;
    const isValidateCheckAddress2 = valueCheckAddress2.toString().trim().length > 100;
    const isValidateCheckCity = valueCheckCity.toString().trim().length > 100;
    const isValidateCheckState = valueCheckState.toString().trim().length > 100;
    const isValidateCheckMobile = valueCheckMobile.toString().trim().length > 20;
    const countries = countryList && typeof countryList.toJS === 'function'
      ? countryList.toJS()
      : countryList || [];

    const regex = /^\d{9}$/;
    const { isValidate } = this.props.form;
    // new UI
    const countryDetails = !!country && typeof country.toJS === 'function' ? country.toJS() : country;
    const isUnitedStates = countryDetails === null ? false : countryDetails.id === defaultCountry.id;
    if (isUnitedStates) {
      this.props.onFormDataChange('form.bankTypeCode', 'Bank Code');
    }
    const isValidateUSABankCode = valueBankCode === '' ? false : valueBankCode.toString().trim().length !== 9 || !regex.test(valueBankCode.trim());
    return (
      <div className="app-content height-payment-details">
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.paymentOptions} />
            </PageSectionHeader>
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-8 form-group'}>
            <Validate
              name="paymentTo"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={paymentTo}
              fieldName={messages.paymentTo}
            >
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Member"
                    checked={paymentTo === 'Member'}
                    onChange={this.handleChangeSelectPaymentTo('form.paymentTo')}
                  />
                  <FormattedMessage {...messages.memberInsured} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Family Member"
                    checked={paymentTo === 'Family Member'}
                    onChange={this.handleChange('form.paymentTo')}
                    onClick={this.props.onResetFormDataAddress}
                  />
                  <FormattedMessage {...messages.familyMember} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Provider"
                    checked={paymentTo === 'Provider'}
                    onChange={this.handleChange('form.paymentTo')}
                    onClick={this.props.onResetFormDataAddress}
                  />
                  <FormattedMessage {...messages.provider} />
                </OptionsContainer>
              </FlexBox>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.paymentTo' }) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'col-sm-4 form-group'}>
          </div>
        </div>
        {(paymentTo !== '' && paymentVia !== 'Check') &&
          <div>
            <div className={'ml-3 row'}>
              <div className={'form-group col-sm-6'}>
                <Validate
                  name="country"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={country}
                  fieldName={messages.country}
                >
                  <AsyncCreatable
                    loadOptions={this.loadCountry}
                    name="country"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      input: (styles) => ({ ...styles, border: 'none !important' }),
                    }}
                    value={
                      !!country && typeof country.toJS === 'function' ? country.toJS() : country
                    }
                    placeholder="Type a country"
                    isClearable
                    isDisabled={isReadOnly}
                    onChange={(e) => {
                      this.handleChangeCountry(e);
                    }}
                    defaultOptions={countries}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.country' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'form-group col-sm-6'}></div>
            </div>
            {(country !== null) &&
              <div>
                {!isUnitedStates &&
                  <div className={'ml-3 row'}>
                    <div className={'col-md-12 form-group'}>
                      <Validate
                        name="bankTypeCode"
                        validators={[required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankTypeCode}
                        fieldName={messages.bankTypeCode}
                      >
                        <FlexBox>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              checked={bankTypeCode === 'Bank Code'}
                              onChange={this.handleChange('form.bankTypeCode')}
                              value="Bank Code"
                            />
                            <FormattedMessage {...messages.bankCode} />
                          </OptionsContainer>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              checked={bankTypeCode === 'SWIFT Code'}
                              onChange={this.handleChange('form.bankTypeCode')}
                              value="SWIFT Code"
                            />
                            <FormattedMessage {...messages.swiftCode} />
                          </OptionsContainer>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              checked={bankTypeCode === 'IBAN'}
                              onChange={this.handleChange('form.bankTypeCode')}
                              value="IBAN"
                            />
                            <FormattedMessage {...messages.IBANText} />
                          </OptionsContainer>
                        </FlexBox>
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankTypeCode' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                    </div>
                  </div>
                }
                {bankTypeCode === 'SWIFT Code' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-8 form-group'}>
                      <Validate
                        name="swiftCode"
                        validators={[required, maxLength(11)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={swiftCode}
                        fieldName={messages.swiftCode}
                      >
                        <Textbox
                          disabled={isReadOnly || isValidate}
                          name="swiftCode"
                          type="text"
                          onChange={this.handleChange('form.swiftCode')}
                          value={swiftCode}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.swiftCode' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateSwiftCode &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidSwiftCode} />
                        </P>
                      }
                    </div>
                  </div>}
                {bankTypeCode === 'IBAN' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-8 form-group'}>
                      <Validate
                        name="iban"
                        validators={[required, maxLength(34)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={iban}
                        fieldName={messages.IBANText}
                      >
                        <Textbox
                          disabled={isReadOnly || isValidate}
                          name="iban"
                          type="text"
                          onChange={this.handleChange('form.iban')}
                          value={iban}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.IBANText}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateIban &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidIban} />
                        </P>
                      }
                      <PageSectionHeader>
                        <FormattedMessage {...messages.reminderIban} />
                      </PageSectionHeader>
                    </div>
                  </div>}
                {(bankTypeCode === 'Bank Code' || bankTypeCode === '') &&
                  <div className={'ml-3 row'}>
                    {isUnitedStates &&
                      <div className={'col-sm-8 form-group'}>
                        <Validate
                          name="bankCode"
                          validators={[required, validUSABankRoutingNumber]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={bankCodeOrRoutingNumber}
                          fieldName={messages.bankCodeOrRoutingNumber9Digits}
                        >
                          <Textbox
                            disabled={isReadOnly}
                            name="bankCode"
                            type="text"
                            onChange={this.handleChange('form.bankCodeOrRoutingNumber')}
                            value={bankCodeOrRoutingNumber}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.bankCodeOrRoutingNumber}
                            />
                          </ErrorMessage>
                        </Validate>
                        {isValidateUSABankCode &&
                          <P style={{ color: 'red', fontSize: '0.7em' }}>
                            <FormattedMessage {...messages.isValidUASBankCode} />
                          </P>
                        }
                      </div>
                    }
                    {!isUnitedStates &&
                      <div className={'col-sm-8 form-group'}>
                        <Validate
                          name="bankCode"
                          validators={[required, maxLength(32)]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={bankCodeOrRoutingNumber}
                          fieldName={messages.bankCodeOrRoutingNumber}
                        >
                          <Textbox
                            disabled={isReadOnly}
                            name="bankCode"
                            type="text"
                            onChange={this.handleChange('form.bankCodeOrRoutingNumber')}
                            value={bankCodeOrRoutingNumber}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.bankCodeOrRoutingNumber}
                            />
                          </ErrorMessage>
                        </Validate>
                        {isValidateBankCode &&
                          <P style={{ color: 'red', fontSize: '0.7em' }}>
                            <FormattedMessage {...messages.isValidBankCode} />
                          </P>
                        }
                      </div>
                    }
                    <div className={'col-sm-4 form-group'}>
                    </div>
                  </div>}
                {bankTypeCode === 'IBAN' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountName"
                        validators={[required, maxLength(128)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountName}
                        fieldName={messages.bankAccountName}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountName"
                          type="text"
                          onChange={this.handleChange('form.bankAccountName')}
                          value={bankAccountName}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountName' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateBankAccountName &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidBankAccountName} />
                        </P>
                      }
                    </div>
                    <div className={'col-sm-6 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.bankAccountNumber} />
                      </PageSectionHeader>
                      <Textbox
                        disabled
                        name="bankAccountNumber"
                        type="text"
                        onChange={this.handleChange('form.bankAccountNumber')}
                        value={bankAccountNumber}
                      />
                    </div>
                  </div>
                }
                {bankTypeCode !== 'IBAN' &&
                  <div className={'ml-3 row'}>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountName"
                        validators={[required, maxLength(128)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountName}
                        fieldName={messages.bankAccountName}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountName"
                          type="text"
                          onChange={this.handleChange('form.bankAccountName')}
                          value={bankAccountName}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountName' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateBankAccountName &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidBankAccountName} />
                        </P>
                      }
                    </div>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="bankAccountNumber"
                        validators={[required, maxLength(17)]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={bankAccountNumber}
                        fieldName={messages.bankAccountNumber}
                      >
                        <Textbox
                          disabled={isReadOnly}
                          name="bankAccountNumber"
                          type="text"
                          onChange={this.handleChange('form.bankAccountNumber')}
                          value={bankAccountNumber}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAccountNumber' }) }}
                          />
                        </ErrorMessage>
                      </Validate>
                      {isValidateAccountNumber &&
                        <P style={{ color: 'red', fontSize: '0.7em' }}>
                          <FormattedMessage {...messages.isValidAccountNumber} />
                        </P>
                      }
                    </div>
                  </div>
                }
                <div className={'ml-3 row'}>
                  <div className={'col-sm-6 form-group'}>
                    <Validate
                      name="bankName"
                      validators={[required, maxLength(64)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bank}
                      fieldName={messages.bankName}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankName"
                        type="text"
                        onChange={this.handleChange('form.bank')}
                        value={bank}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.bankName}
                        />
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankName &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankName' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="bankBranch"
                      validators={[required, maxLength(120)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankBranch}
                      fieldName={messages.bankBranchName}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankBranchName"
                        type="text"
                        onChange={this.handleChange('form.bankBranch')}
                        value={bankBranch}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.bankBranchName}
                        />
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankBranch &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankBranchName' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="bankAddress"
                      validators={[maxLength(120)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankAddress}
                      fieldName={messages.bankAddress}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankAddress"
                        type="text"
                        onChange={this.handleChange('form.bankAddress')}
                        value={bankAddress}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankAddress &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankAddress' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
                <div className={'ml-3 row'}>
                  <div className={'col-sm-8 form-group'}>
                    <Validate
                      name="bankSuburbOrCity"
                      validators={[maxLength(100)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankSuburbOrCity}
                      fieldName={messages.bankSuburbOrCity}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankSuburbOrCity"
                        type="text"
                        onChange={this.handleChange('form.bankSuburbOrCity')}
                        value={bankSuburbOrCity}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankSuburb &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankSuburbOrCity' }) }}
                        />
                      </P>
                    }
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <Validate
                      name="bankPostcode"
                      validators={[maxLength(31)]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={bankPostcode}
                      fieldName={messages.bankPostcode}
                    >
                      <Textbox
                        disabled={isReadOnly || isValidate}
                        name="bankPostcode"
                        type="text"
                        onChange={this.handleChange('form.bankPostcode')}
                        value={bankPostcode}
                      />
                      <ErrorMessage>
                      </ErrorMessage>
                    </Validate>
                    {isValidateBankPostCode &&
                      <P style={{ color: 'red', fontSize: '0.7em' }}>
                        <FormattedMessage
                          {...messages.isMaxLength}
                          values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.bankPostcode' }) }}
                        />
                      </P>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
        {paymentVia === 'Check' &&
          <div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="title"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={title}
                  fieldName={messages.title}
                >
                  <MySelect
                    dataList={titleList}
                    name="title"
                    disabled={isReadOnly}
                    onChange={(v) => {
                      this.handleChangeTitle(v);
                    }}
                    value={title}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.title' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="firstName"
                  validators={[required, maxLength(50)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={firstName}
                  fieldName={messages.firstName}
                >
                  <Textbox
                    name="firstName"
                    type="text"
                    onChange={this.handleChange('form.firstName')}
                    value={firstName}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.firstName' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckFName &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.firstName' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="lastName"
                  validators={[required, maxLength(50)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={lastName}
                  fieldName={messages.lastName}
                >
                  <Textbox
                    name="lastName"
                    type="text"
                    onChange={this.handleChange('form.lastName')}
                    value={lastName}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.lastName' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckLName &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.lastName' }) }}
                    />
                  </P>
                }
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressLine1"
                  validators={[required, maxLength(100)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressLine1}
                  fieldName={messages.addressLine1}
                >
                  <Textbox
                    name="addressLine1"
                    type="text"
                    onChange={this.handleChange('form.addressLine1')}
                    value={addressLine1}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.addressLine1' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckAddress1 &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.addressLine1' }) }}
                    />
                  </P>
                }
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.addressLine2} />
                </PageSectionHeader>
                <Textbox
                  disabled={isReadOnly || isValidate}
                  name="addressLine2"
                  type="text"
                  onChange={this.handleChange('form.addressLine2')}
                  value={addressLine2}
                />
                {isValidateCheckAddress2 &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.addressLine2' }) }}
                    />
                  </P>
                }
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="city"
                  validators={[required, maxLength(100)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={city}
                  fieldName={messages.city}
                >
                  <Textbox
                    name="city"
                    type="text"
                    onChange={this.handleChange('form.city')}
                    value={city}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.city' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckCity &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.city' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="state"
                  validators={[required, maxLength(100)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={state}
                  fieldName={messages.state}
                >
                  <Textbox
                    name="state"
                    type="text"
                    onChange={this.handleChange('form.state')}
                    value={state}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.state' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckState &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.state' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="country"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={country}
                  fieldName={messages.country}
                >
                  <AsyncCreatable
                    loadOptions={this.loadCountry}
                    name="country"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      input: (styles) => ({ ...styles, border: 'none !important' }),
                    }}
                    value={
                      !!country && typeof country.toJS === 'function' ? country.toJS() : country
                    }
                    placeholder="Type a country"
                    isClearable
                    isDisabled={isReadOnly}
                    onChange={(e) => {
                      this.handleChangeCountry(e);
                    }}
                    defaultOptions={countries}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.country' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="postalZipCode"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={postalZipCode}
                  fieldName={messages.postalZipCode}
                >
                  <Textbox
                    name="postalZipCode"
                    type="number"
                    onChange={this.handleChange('form.postalZipCode')}
                    value={postalZipCode}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.postalZipCode' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="mobile"
                  validators={[required, maxLength(20)]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={mobile}
                  fieldName={messages.mobile}
                >
                  <Textbox
                    name="mobile"
                    type="text"
                    onChange={this.handleChangePhoneNumber('form.mobile')}
                    value={mobile}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.mobile' }) }}
                    />
                  </ErrorMessage>
                </Validate>
                {isValidateCheckMobile &&
                  <P style={{ color: 'red', fontSize: '0.7em' }}>
                    <FormattedMessage
                      {...messages.isMaxLength}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepPaymentDetails.mobile' }) }}
                    />
                  </P>
                }
              </div>
              <div className={'col-sm-4 form-group'}>
              </div>
            </div>
          </div>}
        <div className={'row ml-3'}>
          <div className={'form-group col-sm-12'}>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="checkbox"
                value="Check"
                checked={isCheckPayment === true}
                onChange={this.handleChangePaymentViaCheck('form.isCheckPayment')}
                onClick={this.props.onResetFormDataAddress}
              />
              <div style={{ color: '#6d6b6b' }}>
                <FormattedMessage {...messages.alternativelyText} />
              </div>
            </OptionsContainer>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      isSummary,
      submitted,
      loading,
      intl,
      jsonVersion,
      showTrawickPaymentScreen,
    } = this.props;
    const isVersion14AndAbove = jsonVersion >= 14;
    const isReadOnly = submitted || isSummary;
    const isTrawickPaymentScreen = showTrawickPaymentScreen === false ? false : isVersion14AndAbove;
    return (
      <div>
        {(!isTrawickPaymentScreen) && this.renderOldFNOLPaymentScreen()}
        {(isTrawickPaymentScreen) && this.renderV14FNOLPaymentScreen()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className={`${appConfig.reactAppEnv === 'scti' ? 'base-button back-button' : 'btn-outline'}`}
                    onClick={() => {
                      this.props.prev();

                      // make sure next button is not focus, avoid break wizard slider
                      if (document.activeElement) {
                        document.activeElement.blur();
                      }
                    }}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.back' })}
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.save' })}
                </AsyncButton>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

StepPaymentDetails.propTypes = {
  form: PropTypes.object,
  claim: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  currentStep: PropTypes.number,
  step: PropTypes.number,
  isReadOnly: PropTypes.number,
  loading: PropTypes.bool,
  errors: PropTypes.array,
  adjust: PropTypes.func,
  onNext: PropTypes.func,
  makeError: PropTypes.func,
  onResetFormDataAddress: PropTypes.func,
  makeValid: PropTypes.func,
  submitted: PropTypes.bool,
  isSummary: PropTypes.bool,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  titleList: PropTypes.any,
  countryList: PropTypes.any,
  getValidateBank: PropTypes.func,
  getCountryPaymentConfig: PropTypes.func,
  jsonVersion: PropTypes.string,
  showZurichUHC: PropTypes.bool,
  showTrawickPaymentScreen: PropTypes.bool,
  intl: intlShape.isRequired,
};

const mapStateToProps = createStructuredSelector({
  currentStep: makeSelectCurrentStep(),
  form: makeSelectStepPaymentDetails(),
  errors: makeSelectStepPaymentDetailsErrors(),
  loading: makeSelectProgressBarStatus(),
  claim: makeSelectClaimList(),
  titleList: makeSelectTitleList(),
  countryList: makeSelectCountriesOfxSupported(),
  jsonVersion: makeSelectJSONVersion(),
  showZurichUHC: makeSelectShowZurichUHC(),
  showTrawickPaymentScreen: makeSelectShowTrawickPaymentScreen(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormDataAddress: () => dispatch(resetFormDataAddress()),
  getValidateBank: (validateInfo) => dispatch(getValidateBank(validateInfo)),
  getCountryPaymentConfig: (countryId) => dispatch(getCountryPaymentConfig(countryId)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepPaymentDetails', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl
)(StepPaymentDetails);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPaymentDetails/index.js